import { DInterfacePreguntasFormulario } from '@dian-cmp/formulario';

export class DPreguntasFormulario implements DInterfacePreguntasFormulario {
    
    public MOSTRAR_PREGUNTAS:boolean = false;
    public PREGUNTAS_FORMULARIO:Array<any> = [
        {
            titulo: '¿Está sometido al régimen de tributación de las sociedades que desarrollan actividades en las ZOMAC (art. 237 Ley 1819 de 2016) ?',
            descripcion: 'Pregunta 1 de 1',
            multipleRespuesta: false,
            obligatoria: true,
            esFecha: false,
            enviarRespuestaA: {
                seccion: 'cuerpo',
                casilla: 'cs_id_101'
            },
            respuestas: [
                {opcion: 'Si', valor: '1'},
                {opcion: 'No', valor: '0'}
            ]
        }
    ];

}


// WEBPACK FOOTER //
// D:/350/v5/ng_retefuente350v5/Front_formReteFuente350v5/src/app/configuracion/dpreguntas-formulario.ts